import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TagModel } from '@fi-shared/models';
import { ModuleTypes } from '@fi-shared/models/module-types';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-tag-module-type-names',
    template: `@for (moduleTypeName of ModuleTypeNames; track moduleTypeName) {
  <span
    class="CommaSeparated"
    [textContent]="moduleTypeName.Name"
  ></span>
}`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiTagModuleTypeNamesComponent implements OnInit, OnChanges {
    @Input() tag: TagModel;

    constructor(protected appTextService: AppTextService) {}

    ngOnInit(): void {
        this._updateModuleTypeNames();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this._updateModuleTypeNames();
    }

    ModuleTypeNames = [];

    _updateModuleTypeNames() {
        this.ModuleTypeNames = ModuleTypes.filter((mt) => this.tag.ModuleTypes.indexOf(mt.Id) !== -1).map((module) => ({
            Id: module.Id,
            Name: this.appTextService.get(module.TextId),
        }));
    }
}
